module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/reward-a766d5fe4264ecd366418442a350c07f.svg";